/* eslint-disable react/prop-types */
/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import { useState } from 'react';

import Link from 'next/link';

import { List, ListItem, Typography, ListItemIcon, Divider, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import ScreenSearchDesktopIcon from '@material-ui/icons/ScreenSearchDesktop';
import SupportAgentIcon from '@material-ui/icons/SupportAgent';

import clsx from 'clsx';
import PropTypes from 'prop-types';

import Personas from '../../../Personas';

const useStyles = makeStyles(theme => ({
  root: {},
  listItem: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  navLink: {
    '&:hover': {
      color: theme.palette.primary.dark,
    },
  },
  listItemIcon: {
    minWidth: 'auto',
  },
  closeIcon: {
    justifyContent: 'flex-end',
    cursor: 'pointer',
  },
  menu: {
    display: 'flex',
  },
  menuItem: {
    marginRight: theme.spacing(8),
    '&:last-child': {
      marginRight: 0,
    },
  },
  menuGroupItem: {
    paddingTop: 0,
  },
  menuGroupTitle: {
    textTransform: 'uppercase',
  },
  divider: {
    width: '100%',
  },
}));

const SidebarNav = props => {
  const { pages, onClose, className, ...rest } = props;

  const classes = useStyles();
  const [personas, setPersonas] = useState(false);

  const { solutions, platform, theCompany } = pages;

  const MenuGroup = p => {
    const { item } = p;
    return (
      <List disablePadding>
        <ListItem disableGutters>
          <Typography variant="body2" color="primary" className={classes.menuGroupTitle}>
            {item.groupTitle}
          </Typography>
        </ListItem>
        {item.pages.map((page, i) => (
          <ListItem disableGutters key={i.toString()} className={classes.menuGroupItem}>
            <Link href={page.href} passHref>
              <Typography
                variant="body2"
                component="a"
                className={clsx(classes.navLink, 'submenu-item')}
                color="textPrimary"
                onClick={() => onClose()}>
                {page.title}
              </Typography>
            </Link>
          </ListItem>
        ))}
      </List>
    );
  };

  const SolutionsPages = () => {
    const { institutions, sellers, extra, customers } = solutions.children;
    return (
      <div className={classes.menu}>
        <div className={classes.menuItem}>
          <MenuGroup item={institutions} />
          <MenuGroup item={sellers} />
          <MenuGroup item={customers} />
          <MenuGroup item={extra} />
        </div>
      </div>
    );
  };

  const PlatformPages = () => {
    const { onlineSales, customerSupport, payments, integrations, orders, management } =
      platform.children;
    return (
      <div className={classes.menu}>
        <div className={classes.menuItem}>
          <MenuGroup item={onlineSales} />
          <MenuGroup item={customerSupport} />
          <MenuGroup item={payments} />
        </div>
        <div className={classes.menuItem}>
          <MenuGroup item={integrations} />
          <MenuGroup item={orders} />
          <MenuGroup item={management} />
        </div>
      </div>
    );
  };

  const TheCompanyPages = () => {
    const { eskolare, resources, legal } = theCompany.children;
    return (
      <div className={classes.menu}>
        <div className={classes.menuItem}>
          <MenuGroup item={eskolare} />
          <MenuGroup item={legal} />
        </div>
        <div className={classes.menuItem}>
          <MenuGroup item={resources} />
        </div>
      </div>
    );
  };

  return (
    <List {...rest} className={clsx(classes.root, className)}>
      <ListItem className={classes.closeIcon} onClick={() => onClose()}>
        <ListItemIcon className={classes.listItemIcon}>
          <CloseIcon fontSize="small" />
        </ListItemIcon>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Typography variant="h6" color="textPrimary" gutterBottom>
          Soluções
        </Typography>
        <SolutionsPages />
      </ListItem>
      <ListItem className={classes.listItem}>
        <Divider className={classes.divider} />
      </ListItem>
      <ListItem className={classes.listItem}>
        <Typography variant="h6" color="textPrimary" gutterBottom>
          Plataforma
        </Typography>
        <PlatformPages />
      </ListItem>
      <ListItem className={classes.listItem}>
        <Divider className={classes.divider} />
      </ListItem>
      <ListItem className={classes.listItem}>
        <Typography variant="h6" color="textPrimary" gutterBottom>
          Empresa
        </Typography>
        <TheCompanyPages />
      </ListItem>
      <ListItem className={classes.listItem}>
        <Link href="/contact" passHref>
          <Button
            startIcon={<SupportAgentIcon />}
            variant="outlined"
            color="primary"
            fullWidth
            component="a"
            aria-label="Atendimento">
            Atendimento
          </Button>
        </Link>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Link href="/orders" passHref>
          <Button
            startIcon={<ScreenSearchDesktopIcon />}
            variant="outlined"
            color="primary"
            fullWidth
            component="a"
            aria-label="Pedidos">
            Pedidos
          </Button>
        </Link>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button variant="contained" color="primary" fullWidth onClick={() => setPersonas(true)}>
          Entrar
        </Button>
        <Personas open={personas} onClose={() => setPersonas(false)} />
      </ListItem>
    </List>
  );
};

SidebarNav.propTypes = {
  className: PropTypes.string,
  pages: PropTypes.object.isRequired,
  onClose: PropTypes.func,
};

export default SidebarNav;
